export const ROUTES = {
  NATIONAL_TEAM: "/widgets/national-team/:type",
};
